import Choices from "choices.js";
import { SelectBoxOption } from "./select-box-option";

export const initSelectBox = (element: HTMLSelectElement, options: SelectBoxOption[] = [], selectedValue = "") => {
    if (!element) return null;

    if (selectedValue && options?.length) {
        options.forEach((choice) => {
            if (choice.value == selectedValue) {
                choice.selected = true;
            } else {
                choice.selected = false;
            }
        });
    }

    return new Choices(element, {
        choices: options,
        searchEnabled: false,
        shouldSort: false,
        allowHTML: false,
        itemSelectText: "",
    });
};

export const resetSelectOptions = (choices: Choices, options: SelectBoxOption[], selectedValue = "") => {
    if (selectedValue) {
        options.forEach((choice) => {
            if (choice.value == selectedValue) {
                choice.selected = true;
            } else {
                choice.selected = false;
            }
        });
    }

    choices.setChoices(options, "value", "label", true);
};

export function useSelectBox() {
    const elements = document.querySelectorAll<HTMLSelectElement>("select:not(.no-global-selectbox)");

    elements.forEach((element) => {
        initSelectBox(element);
    });
}
